import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import { IC_VIDEO_PDP, PRODUCT_CARD_DEFAULT } from '@common/Assets/images';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
const CategoryItem = ({ detailsData, active, setActive, position, categoryImage = '', setSelectedImage, setSelectedMedia, setVideoTitle, setShowVideo, setSelectedMediaId, item, showMobileSlider }) => {
  return (
    <>
      {detailsData?.mediaGalleryEntries?.length >= 1 && (
        <div className="categoryItemBox">
          <div className={active === position ? 'item-wrapper active' : 'item-wrapper'}>
            <div className="product-thumb">
              <Image
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = PRODUCT_CARD_DEFAULT?.src;
                }}
                width="400px"
                height="400px"
                data-test="categoryImageId"
                onClick={() => {
                  setSelectedImage(categoryImage);
                  setActive(position);
                  setSelectedMedia(item?.mediaType);
                  setSelectedMediaId(item?.videoContent?.videoUrl?.split('?v=')[1]);
                  setVideoTitle(item?.videoContent?.videoTitle);

                  if(showMobileSlider && item?.mediaType === 'external-video') {
                    setShowVideo(true);
                  }
                }}
                src={getImageUrlWithSize(categoryImage, 400, 400)}
                alt={detailsData?.name}
                title={detailsData?.name}
                unoptimized
              />
              {item?.mediaType === 'external-video' && 
                <div className='videoThumb' onClick={() => {
                (showMobileSlider && item?.mediaType === 'external-video') && setShowVideo(true);
                  setSelectedImage(categoryImage);
                  setActive(position);
                  setSelectedMedia(item?.mediaType);
                  setSelectedMediaId(item?.videoContent?.videoUrl?.split('?v=')[1]);
                  setVideoTitle(item?.videoContent?.videoTitle);
                  }}>
                  <Image src={IC_VIDEO_PDP} width={24} height={24}/>
                </div>
              }
            </div>
          </div>
        </div>
      )}
    </>
  );
};

CategoryItem.propTypes = {
  categoryImage: PropTypes.string,
  categoryName: PropTypes.string,
  position: PropTypes.string,
  detailsData: PropTypes.any,
  setSelectedImage: PropTypes.any,
  setActive: PropTypes.any,
  active: PropTypes.any,
  showMobileSlider: PropTypes.bool
};
CategoryItem.defaultProps = {
  categoryImage: '',
  categoryName: '',
  position: '',
  showMobileSlider: false
};

export default CategoryItem;
